var _text, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoVnp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVGRoot",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 47.507015,
    y: 84.456917,
    fill: "#000000",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 47.507015,
    y: 84.456917
  }))), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontSize: "253.33px",
    style: {
      shapeInside: "url(#rect135)",
      shapePadding: 2.63928,
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("text", {
    x: 81.817635,
    y: 110.8497,
    fill: "#ff0000",
    fontSize: "253.33px",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 81.817635,
    y: 110.8497
  })), /*#__PURE__*/React.createElement("text", {
    x: 150.43887,
    y: 197.94589,
    fill: "#ff0000",
    fontSize: "192px",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 150.43887,
    y: 197.94589
  })), /*#__PURE__*/React.createElement("text", {
    x: 240.17435,
    y: 314.07416,
    fill: "#327e81",
    fontSize: "192px",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 240.17435,
    y: 314.07416
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 205.86372,
    y: 274.48495,
    fill: "#327e80",
    fontSize: "192px",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 205.86372,
    y: 274.48495
  })), /*#__PURE__*/React.createElement("g", {
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "scale(.78745 1.2699)",
    x: 21.318817,
    y: 351.23068,
    fill: "#327e80",
    fontSize: "408.46px",
    strokeWidth: 2.1274,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 21.318817,
    y: 351.23068,
    fontFamily: "sans-serif",
    fontWeight: "bold",
    strokeWidth: 2.1274
  }, "V")), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.81787 1.2227)",
    x: 274.99219,
    y: 362.64175,
    fill: "#004355",
    fontSize: "421.27px",
    strokeWidth: 2.1941,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 274.99219,
    y: 362.64175,
    fontFamily: "sans-serif",
    fontWeight: "bold",
    strokeWidth: 2.1941
  }, "N")), /*#__PURE__*/React.createElement("text", {
    transform: "scale(1.0527 .94992)",
    x: 317.79413,
    y: 461.16031,
    fill: "#ff8d22",
    fontSize: "78.105px",
    strokeWidth: 0.4068,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 317.79413,
    y: 461.16031,
    fontFamily: "sans-serif",
    fontWeight: "bold",
    strokeWidth: 0.4068
  }, "pro"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVnp);
export default __webpack_public_path__ + "static/media/logo_VNP.6172dd4630676604487046ebc8174f96.svg";
export { ForwardRef as ReactComponent };